export default function postToken() {
  try {
    if (window.native) {
      return window.native.postToken();
    }
  } catch (error) {
    return null;
  }
}
